<!-- 空状态 -->
<template>
  <!-- <div class=''></div>
   -->
  <van-empty
    class="custom-image"
    :image="img"
    :description="info"
  />
</template>

<script>
import Vue from 'vue'
import { Empty } from 'vant'
Vue.use(Empty)
export default {
  name: 'CusEmpty',
  props: {
    info: {
      type: String,
      default: '暂无数据'
    }
  },
  data() {
    return {
      img: require('@a/img/default/empty.png')
    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less'>
.custom-image {
  .van-empty__image {
    width: 85px;
    height: 65px;
  }
}
</style>